import React, { createContext, useState, useEffect, useMemo } from 'react'
import useRawState from '../hooks/useRawState'
import LocalStorage from '../services/LocalStorage'

const PitchListContext = createContext()

function PitchListProvider({ pagination = false, ...props }) {
    const { data, isBusy, ...state } = useRawState(
        `/api/current/pitches/list`,
        { pagination },
        [pagination],
    )
    const [sortAlphabetical, setSortAlphabetical] = useState(LocalStorage.getItem('setting-sortAlphabetical') === true)

    useEffect(() => {
        LocalStorage.setItem('setting-sortAlphabetical', sortAlphabetical)
    }, [sortAlphabetical])

    const sortedPitches = useMemo(() => {
        if (!data) return []
        return sortAlphabetical ?
            [...data].sort((a, b) => a?.name?.localeCompare(b?.name, undefined, { sensitivity: 'base' }))
            : data
    }, [data, sortAlphabetical])

    return (
        <PitchListContext.Provider
            {...props}
            value={{
                pitches: sortedPitches,
                defaultOrderPitches: data || [],
                sortAlphabetical: sortAlphabetical,
                setSortAlphabetical: setSortAlphabetical,
                isBusy: isBusy,
                ...state
            }}
        />
    )
}

export default PitchListContext
export { PitchListProvider }